import axios from "@/axios"

const url = "/api/brain/specimens/temperaments"

class SpecimenTemperamentService {
	async getTemperaments(params) {
		try {
			const { data } = await axios.get(`${url}`, { params })
			return data
		} catch (error) {
			throw error
		}
	}

	async storeTemperament(params) {
		try {
			const { data } = await axios.post(`${url}`, params)
			return data
		} catch (error) {
			throw error
		}
	}

	async switchActive(id) {
		try {
			const { data } = await axios.put(`${url}/switch-active/${id}`)
			return data
		} catch (error) {
			throw error
		}
	}

	async updateTemperament(id, params) {
		try {
			const { data } = await axios.put(`${url}/${id}`, params)
			return data
		} catch (error) {
			throw error
		}
	}

	async deleteTemperament(id) {
		try {
			const { data } = await axios.delete(`${url}/${id}`)
			return data
		} catch (error) {
			throw error
		}
	}

	async storeSpecimenTemperament(params) {
		try {
			const { data } = await axios.post(`${url}/specimen`, params)
			return data
		} catch (error) {
			throw error
		}
	}

	async getSpecimenTemperamentTracking(id) {
		try {
			const { data } = await axios.get(`${url}/specimen/${id}`)
			return data
		} catch (error) {
			throw error
		}
	}
}

export default new SpecimenTemperamentService()
